export enum Blockchain {
  FIAT = 'FIAT',
  ETH = 'ETH',
  TRX = 'TRX',
  BTC = 'BTC',
}
